const PASSWORD_LOGIN_DOMAINS = ["scp-epi-homol.supplybrain.ai"];

export const isPasswordLoginDomain = (): boolean =>
	PASSWORD_LOGIN_DOMAINS.includes(window.location.hostname);
